function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
import mediaMin from '../styles/breakpoints';
import { shade, themify } from '../styles/mixins';
export const RadioLabel = styled.label.withConfig({
  displayName: "Radio__RadioLabel",
  componentId: "sc-1l95bde-0"
})(["position:relative;display:inline-flex;align-items:center;vertical-align:top;padding-right:1em;padding-left:3em;height:3em;border:1px solid ", ";color:", ";border-radius:3px;background:white;box-shadow:inset 0 1px 1px rgba(0,0,0,0.075);width:100%;text-align:left;font-size:", ";line-height:1;cursor:pointer;transition:all 0.125s;", ";&::before{content:'';position:absolute;left:1em;top:calc(50% - 0.5em);display:inline-block;overflow:hidden;width:1em;height:1em;border:1px solid ", ";box-shadow:0 2px 2px -1px rgba(0,0,0,0.075);border-radius:100%;background:white;vertical-align:top;transition:all 0.125s;cursor:pointer;}&:hover{white-space:normal;overflow:visible;text-overflow:unset;border:1px solid ", ";background:", ";&::before{border:1px solid ", ";}}&:active{outline:none;border:1px solid ", ";}"], x => x.$borderColor, x => x.$color, x => x.theme.type.scale[x.$fontSize], x => !x.$mobile && css(["", "{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:", ";}"], mediaMin.md, x => x.$width), x => x.$borderColor, x => x.$bgColor, x => x.theme.colors.grayLighter, x => x.$bgColor, x => shade(0.9, x.$bgColor));
export const StyledRadio = styled.input.withConfig({
  displayName: "Radio__StyledRadio",
  componentId: "sc-1l95bde-1"
})(["position:absolute;left:-9999px;opacity:0;transition:all 0.25s;appearance:none;&:checked + label{border:1px solid ", ";background:", ";box-shadow:none;font-weight:600;color:white;&::before{content:'';border:2px solid white;color:", ";background:", ";}&:hover{background:", ";}&:active{background:", ";box-shadow:inset 0 0 3px 3px ", ";text-shadow:1px 1px 3px ", ";}& a{color:white;&:hover{color:", ";}}}&:disabled{pointer-events:none;cursor:default;& + label{pointer-events:none;border:1px solid ", ";background:", ";color:", ";cursor:default;&::before{border:1px solid ", ";color:white;background:", ";}}}&.invalid{border:1px solid ", ";}"], x => shade(0.9, x.$bgColor), x => x.$bgColor, x => x.$bgColor || 'white', x => shade(0.85, x.$bgColor), x => shade(0.9, x.$bgColor), x => shade(0.9, x.$bgColor), x => shade(0.85, x.$bgColor), x => shade(0.85, x.$bgColor), x => x.theme.colors.grayDarker, x => x.theme.colors.gray, x => x.theme.colors.grayLighter, x => x.theme.colors.grayDark, x => x.theme.colors.gray, x => x.theme.colors.grayLight, x => x.theme.colors.red);

const RadioFunc = (_ref) => {
  let {
    bgColor = 'green',
    borderColor = 'gray',
    className,
    color = 'grayDarker',
    disabled = false,
    fontSize = 5,
    id,
    itemKey,
    label,
    mobile,
    onChange,
    value,
    width = 'auto'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["bgColor", "borderColor", "className", "color", "disabled", "fontSize", "id", "itemKey", "label", "mobile", "onChange", "value", "width"]);

  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: itemKey
  }, /*#__PURE__*/React.createElement(StyledRadio, _extends({
    $bgColor: themify(bgColor),
    disabled: disabled,
    id: id,
    onChange: disabled ? undefined : () => onChange(value),
    type: "radio",
    value: value
  }, rest)), /*#__PURE__*/React.createElement(RadioLabel, {
    $bgColor: themify(bgColor),
    $borderColor: themify(borderColor),
    $color: themify(color),
    $fontSize: fontSize,
    $mobile: mobile,
    $width: width,
    className: className,
    htmlFor: id
  }, label));
};

RadioFunc.displayName = 'Radio';
export const Radio = withSpacing(RadioFunc, {
  mr: 1,
  mb: 1
});